import React, { FC, useCallback, useEffect, useState } from 'react';
import { Input } from 'antd';
import { useParams } from 'react-router-dom';

import { AttributesProps, Position } from '../service/attributes.interface';
import { useCreatePositionMutation } from '../service/attributes';

export const PositionInput: FC<AttributesProps> = ({ position, id }) => {
    const { id: shop_id } = useParams<{ id: string }>();
    const [value, setValue] = useState<Position>(position);

    const [createPosition, { isLoading }] = useCreatePositionMutation();

    useEffect(() => {
        setValue(position);
    }, [position]);

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const inputValue = e.target.value;
            if (inputValue === '' || /^\d+$/.test(inputValue)) {
                setValue(inputValue === '' ? 0 : Number(inputValue));
            }
        },
        []
    );

    const handleBlur = useCallback(() => {
        if (position !== value && shop_id) {
            createPosition({
                shop_id: Number(shop_id),
                id,
                position: value,
            });
        }
    }, [shop_id, id, value, position, createPosition]);

    return (
        <Input
            disabled={isLoading}
            onBlur={handleBlur}
            onChange={handleChange}
            value={value === 0 ? '' : String(value)}
            inputMode='numeric'
            min={0}
            max={9999}
            placeholder='Позиция'
        />
    );
};
